export const saveFile = (rows, columns, listItems, savedStyles) => {

    const scanDOMForFavSavedStyles = () => {
        console.log("scanDOMForFavSavedStyles Ready!");

        const container = document.getElementById('fixedPositionFavoriteStylesContainer');
        if (container) {
            console.log("scanDOMForFavSavedStyles Found fixedPositionFavoriteStylesContainer.");

            const favButtonGroups = container.querySelectorAll('[id^="favButtonGroupBox-"]');
            if (favButtonGroups.length > 0) {
                const ids = Array.from(favButtonGroups).map(el => el.id);
                console.log(`scanDOMForFavSavedStyles Found instances of favButtonGroupBox in fixedPositionFavoriteStylesContainer: ${ids.join(', ')}`);
                return ids;
            } else {
                console.log("scanDOMForFavSavedStyles DID NOT FIND instances of favButtonGroupBox in fixedPositionFavoriteStylesContainer.");
            }
        } else {
            console.log("scanDOMForFavSavedStyles DID NOT FIND fixedPositionFavoriteStylesContainer.");
        }
        return []; // return empty array if not found
    };
    const favSavedStyles = scanDOMForFavSavedStyles(); // Call and store the array

    const data = {
        rows,
        columns,
        tagLibrary: listItems,
        selectedTags: rows.map(row => {
            const rowSelections = {};
            columns.forEach(col => {
                rowSelections[`column${col.id}`] = row[`column${col.id}_selected`] || [];
            });
            return { rowId: row.id, selections: rowSelections };
        }),
        savedStyles,
        favSavedStyles
    };

    const fileNameInput = document.getElementById('fileNameInput');
    let baseFileName = (fileNameInput && fileNameInput.value.trim()) || fileNameInput.placeholder || 'Untitled Draft';
    let fullFileName = `${baseFileName}.onewriter`;

    const existingFiles = JSON.parse(localStorage.getItem('savedFilenames')) || [];

    if (existingFiles.includes(fullFileName)) {
        const shouldReplace = window.confirm(`A file named "${fullFileName}" already exists. Do you want to replace it? Click "Cancel" to save as a new version.`);

        if (!shouldReplace) {
            let index = 1;
            while (existingFiles.includes(`${baseFileName} (${index}).onewriter`)) {
                index++;
            }
            fullFileName = `${baseFileName} (${index}).onewriter`;
        }
    }

    if (!existingFiles.includes(fullFileName)) {
        existingFiles.push(fullFileName);
        localStorage.setItem('savedFilenames', JSON.stringify(existingFiles));
    }

    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fullFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
